const DestinationAdsOptions = [
  ["googleHotelAdsPropertyPromotionAds", "Google Hotel Ads - Property Promotion Ads", "GHA_PPA"],
  ["tripadvisorSponsoredPlacement", "Tripadvisor - Sponsored Placement", "TRIPADVISOR_SP"],
  ["trivagoSponsoredListing", "Trivago Sponsored Listing", "TRIVAGO_SL"],
];

export const DashboardDestinationAdsOptions = DestinationAdsOptions.map(([id, label, channel_id]) => ({
  id,
  label,
  channel_id,
  isSelected: true,
}));
